const initialState = {
  status: "invalid",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "SETTINGS_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "SETTINGS_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action,
      };
    case "SETTINGS_FAILURE":
      return {
        ...state,
        status: "failure",
      };

    default:
      return state;
  }
};
